import { render, staticRenderFns } from "./OTTqiantie.vue?vue&type=template&id=beb7f5ec&scoped=true&"
import script from "./OTTqiantie.vue?vue&type=script&lang=ts&"
export * from "./OTTqiantie.vue?vue&type=script&lang=ts&"
import style0 from "./OTTqiantie.vue?vue&type=style&index=0&id=beb7f5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb7f5ec",
  null
  
)

export default component.exports